// Classifies a workout plan as coach-assigned or personal (self-created in the
// Flex app) from assigned_to_id/assigned_by_id. assigned_to_id is scoped to
// the tracking response as a whole (the viewed client), not to each plan, so
// it's passed in separately rather than read off the plan object. This
// equality-based heuristic is otherwise unverified against the backend
// contract — kept behind this single function so it can be swapped for an
// explicit plan_type field later without touching call sites.
export function resolvePlanCategory(plan, viewedClientId) {
  return viewedClientId === plan?.assigned_by_id ? "personal" : "coach";
}

export function filterSessionsByCategory(sessions, category) {
  if (!category) return sessions;
  return (sessions || []).filter(
    (session) => session.planCategory === category
  );
}
